// Copyright © 2015-2020 TrampleZone LLC All Rights Reserved

// Tooltip Module

// Show a tooltip for any target element.  Tooltip types can be error,
// warning, info, success or blank.

// @param target the element on which to place the tooltip
// @param message the message to include in the tooltip
// @param type the type of tooltip which determines the image and color

define('Tooltip',['require','Utilities'],function (require) {
    'use strict';

    var // Require.js module dependencies
        Utilities = require('Utilities'),

        // Instance vars
        utilities;

    // Constructor
    function Tooltip(target, message, currentType) {

        // Dependent Resources
        utilities = new Utilities();

        // Instance vars
        this.target = target;
        this.message = message || '';
        this.currentType = currentType || this.type.BLANK;

        // Private vars
        var tooltipDiv,
            tooltipMessageDiv,
            tooltipSpan,
            parent = window.document.body;

        // Public API

        // Set the message for this tooltip
        this.setMessage = function (newMessage) {
            this.message = newMessage;
            tooltipMessageDiv.innerHTML = this.message;
        };

        // Set the type for this tooltip
        this.setType = function (newType) {
            if (newType != null && typeof this.type[newType] !== undefined) {
                var divClass, tooltipType;
                // Check if the specified type is in the supported list
                for (tooltipType in this.type) {
                    if (this.type.hasOwnProperty(tooltipType)) {
                        divClass = 'tooltip-' + tooltipType.substring(
                            tooltipType.lastIndexOf('.') + 1
                        ).toLowerCase();
                        if (this.type[tooltipType] === newType) {
                            // Add new type class to elements
                            tooltipDiv.classList.add(divClass);
                        } else {
                            // Remove class if present for other types
                            tooltipDiv.classList.remove(divClass);
                        }
                    }
                }
            } else {
                console.log('WARNING: Invalid tooltip type - ' + newType);
            }
        };

        // Show the tooltip
        this.show = function () {
            // Add tooltip to DOM so we can get dimensions
            if (!utilities.isDescendant(parent, tooltipDiv)) {
                parent.appendChild(tooltipDiv);
            }
            // Position tooltip near target and enable
            this.position();
            // Zoom down and make visible in preparation to show
            tooltipDiv.classList.add('zoom-down');
            // Zoom out to display the tooltip
            setTimeout(function () {
                tooltipDiv.classList.add('show-tooltip');
            }, 50);
        };

        // Position the tooltip near the element
        this.position = function () {
            var targetPosition = this.target.getBoundingClientRect();
            var parentPosition = parent.getBoundingClientRect();
            var tooltipPosition = tooltipDiv.getBoundingClientRect();
            tooltipDiv.style.top =
                (targetPosition.top - parentPosition.top) -      // top of target
                (tooltipPosition.bottom - tooltipPosition.top) - // tooltip height
                20 + 'px';                                       // size of arrow
            tooltipDiv.style.left =
                (targetPosition.left - parentPosition.left) +
                ((targetPosition.right - targetPosition.left) -
                 (tooltipPosition.right - tooltipPosition.left))/2 + 'px';
        };

        // Hide the tooltip
        this.hide = function () {
            tooltipDiv.classList.add('enable');
            tooltipDiv.classList.remove('show-tooltip');
            setTimeout(function () {
                if (utilities.isDescendant(parent, tooltipDiv)) {
                    parent.removeChild(tooltipDiv);
                }
                tooltipDiv.classList.remove('enable');
                tooltipDiv.classList.remove('zoom-down');
            }.bind(this), 450);
        };

        // Set the color for this tooltip
        this.setColor = function (newColor) {
            if (newColor) {
                tooltipDiv.style.color = newColor;
            }
        };

        // Set the backcolor for this tooltip
        this.setBackgroundColor = function (newColor) {
            if (newColor) {
                tooltipDiv.style.backgroundColor = newColor;
            }
        };

        // Constructor

        // Create the tooltip elements and assemble
        tooltipDiv = document.createElement('div');
        tooltipMessageDiv = document.createElement('div');
        tooltipSpan = document.createElement('span');
        tooltipDiv.appendChild(tooltipMessageDiv);
        tooltipDiv.appendChild(tooltipSpan);
        tooltipDiv.classList.add('tooltip');
        tooltipSpan.classList.add('arrow');

        // Set the message to show
        this.setMessage(this.message);

        // Set the type of the tooltip
        this.setType(this.currentType);

        // Hide the tooltip if clicked/tapped
        utilities.addEventListeners(tooltipDiv, function () {
            this.hide();
        }.bind(this));
    }

    // Class static to define the types for tooltips
    Tooltip.prototype.type = Object.freeze({
        BLANK: 0,
        ERROR: 1,
        WARNING: 2,
        INFO: 3,
        SUCCESS: 4,
    });

    // Set container foreground color
    Tooltip.prototype.setForegroundColor = function (newColor) {
        this.setColor(newColor);
    };

    // Set container background color
    Tooltip.prototype.setBackgroundColor = function (newColor) {
        this.setBackgroundColor(newColor);
    };

    // Return Constructor
    return Tooltip.prototype.constructor;
});

